import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import ButtonEyeNoRead from "../../../components/Button/ButtonEyeNoRead";
import ButtonEyeRead from "../../../components/Button/ButtonEyeRead";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import "./NotificationCard.css";

const NotificationCard = ({
  notification,
  toggleReadStatus,
  handleDeleteNotification,
}) => {
  const [swipeDirection, setSwipeDirection] = useState(null);

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setSwipeDirection("left");
      setTimeout(() => {
        toggleReadStatus(notification.id);
        setSwipeDirection(null);
      }, 220);
    },
    onSwipedRight: () => {
      setSwipeDirection("right");
      setTimeout(() => {
        handleDeleteNotification(notification.id);
        setSwipeDirection(null);
      }, 220);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const dateStr = new Date(notification.created_at).toLocaleDateString(
    "fr-FR",
    { year: "2-digit", month: "2-digit", day: "2-digit" }
  );
  const timeStr = new Date(notification.created_at).toLocaleTimeString(
    "fr-FR",
    { hour: "2-digit", minute: "2-digit" }
  );

  return (
    <div
      className={`notification-card shadow-md rounded-lg p-3 mb-3 transition ${
        notification.read_notification ? "bg-gray-100" : "bg-white"
      } ${swipeDirection === "left" ? "swipe-left" : ""} ${
        swipeDirection === "right" ? "swipe-right" : ""
      }`}
      {...handlers}
    >
      {/* Date + heure + actions */}
      <div className="flex justify-between items-start mb-1">
        <div className="flex flex-col">
          <span className="text-xs font-semibold text-gray-900">{dateStr}</span>
          <span className="text-[10px] text-gray-500">{timeStr}</span>
        </div>
        <div className="flex space-x-1">
          {notification.read_notification ? (
            <ButtonEyeRead
              onClick={() => toggleReadStatus(notification.id)}
              hoverLabel="Marquer comme non lu"
            />
          ) : (
            <ButtonEyeNoRead
              onClick={() => toggleReadStatus(notification.id)}
              hoverLabel="Marquer comme lu"
            />
          )}
          <ButtonDelete
            onClick={() => handleDeleteNotification(notification.id)}
            hoverLabel="Supprimer"
          />
        </div>
      </div>

      {/* Message compact */}
      <div className="text-[13px] leading-snug text-gray-700">
        {notification.message}
      </div>

      {/* Aides visuelles swipe (optionnel) */}
      {swipeDirection === "left" && (
        <div className="swipe-icon">
          {notification.read_notification ? (
            <ButtonEyeNoRead hoverLabel="Marquer comme non lu" />
          ) : (
            <ButtonEyeRead hoverLabel="Marquer comme lu" />
          )}
        </div>
      )}
      {swipeDirection === "right" && (
        <div className="swipe-icon">
          <ButtonDelete hoverLabel="Supprimer" />
        </div>
      )}
    </div>
  );
};

export default NotificationCard;
